export const READ_USER_SESSION_V1_FUNCTION = 'readUserSessionV1';
export const ROUTE_ERROR = '/en-us/banking/error';

export const PERSONAL_CHECKING_ROUTE = '/en-us/banking/personal/checking';
export const PERSONAL_SAVINGS_ROUTE = '/en-us/banking/personal/savings';
export const DEFAULT_VIEW_DISABLED_ROUTES = [
  PERSONAL_CHECKING_ROUTE,
  PERSONAL_SAVINGS_ROUTE,
];
